import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgGovernmentIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    clipRule="evenodd"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M1.25 9c0 .414.336.75.75.75h20c.414 0 .75-.336.75-.75V7c0-.284-.161-.544-.415-.671l-9.552-4.776a1.747 1.747 0 0 0-1.566 0L1.665 6.329A.751.751 0 0 0 1.25 7zm1.5-.75v-.786l9.138-4.57a.252.252 0 0 1 .224 0l9.138 4.57v.786zM7.25 11c0-.414-.336-.75-.75-.75h-3c-.414 0-.75.336-.75.75v7c0 .414.336.75.75.75h3c.414 0 .75-.336.75-.75zm-1.5.75v5.5h-1.5v-5.5zM14.25 11c0-.414-.336-.75-.75-.75h-3c-.414 0-.75.336-.75.75v7c0 .414.336.75.75.75h3c.414 0 .75-.336.75-.75zm-1.5.75v5.5h-1.5v-5.5zM21.25 11c0-.414-.336-.75-.75-.75h-3c-.414 0-.75.336-.75.75v7c0 .414.336.75.75.75h3c.414 0 .75-.336.75-.75zm-1.5.75v5.5h-1.5v-5.5z" />
    <path d="M21.75 9c0-.414-.336-.75-.75-.75h-4c-.414 0-.75.336-.75.75v2c0 .414.336.75.75.75h4c.414 0 .75-.336.75-.75zm-1.5.75v.5h-2.5v-.5zM21.75 18c0-.414-.336-.75-.75-.75h-4c-.414 0-.75.336-.75.75v2c0 .414.336.75.75.75h4c.414 0 .75-.336.75-.75zm-1.5.75v.5h-2.5v-.5zM14.75 9c0-.414-.336-.75-.75-.75h-4c-.414 0-.75.336-.75.75v2c0 .414.336.75.75.75h4c.414 0 .75-.336.75-.75zm-1.5.75v.5h-2.5v-.5zM14.75 18c0-.414-.336-.75-.75-.75h-4c-.414 0-.75.336-.75.75v2c0 .414.336.75.75.75h4c.414 0 .75-.336.75-.75zm-1.5.75v.5h-2.5v-.5z" />
    <path d="M22.75 20c0-.414-.336-.75-.75-.75H2c-.414 0-.75.336-.75.75v2c0 .414.336.75.75.75h20c.414 0 .75-.336.75-.75zm-1.5.75v.5H2.75v-.5zM7.75 9c0-.414-.336-.75-.75-.75H3c-.414 0-.75.336-.75.75v2c0 .414.336.75.75.75h4c.414 0 .75-.336.75-.75zm-1.5.75v.5h-2.5v-.5z" />
    <path d="M7.75 18c0-.414-.336-.75-.75-.75H3c-.414 0-.75.336-.75.75v2c0 .414.336.75.75.75h4c.414 0 .75-.336.75-.75zm-1.5.75v.5h-2.5v-.5z" />
  </svg>
);
export default SvgGovernmentIcon;
